import type {
  CoreApiRequestPayload,
  CoreBookingDocument,
  CoreBookingDocumentPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Update a booking document by ID.
 *
 * @endpoint PUT /api/saas/me/bookings/{bookingId}/documents/{documentId}
 * @scope saas
 * @see https://flecto.dev/api-5629896
 */
export async function updateBookingDocument(
  bookingId: ParameterID,
  documentId: ParameterID,
  document: CoreBookingDocumentPayload
): Promise<CoreBookingDocument> {
  const body: CoreBookingDocumentPayload = {
    filename_base: document.filename_base,
    category: document.category,
    visible_to_renter: document.visible_to_renter,
    file_id: String(documentId),
  }

  const response = await api.put(
    `/api/saas/me/bookings/${bookingId}/documents/${documentId}`,
    body
  )

  return response?.data?.booking_document
}
